import { render, staticRenderFns } from "./week-form.vue?vue&type=template&id=5521a1a0&"
import script from "./week-form.vue?vue&type=script&lang=js&"
export * from "./week-form.vue?vue&type=script&lang=js&"
import style0 from "./week-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports